module.exports = __webpack_public_path__ + "img/marcyrl.3fee07af.jpg";